var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-field"},[_c('input',{staticClass:"input",attrs:{"maxlength":_vm.maxlength,"type":_vm.type,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.updateValue($event.target.value)}}}),(_vm.error !== '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }